<template>
  <nav class="navbar navbar-expand-lg portal-navbar">
    <span v-if="entorno" class="entorno-badge">
      {{ nombreEntorno }}
    </span>
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="navbar-minimize col-auto pe-0">
          <button
            type="button"
            class="boton-icono d-none d-lg-flex"
            aria-label="Plegar o desplegar el menú"
            title="Plegar o desplegar el menú"
            @click="abrirSideBar"
          >
            <i
              :class="
                $sidebar.isMinimized ? 'fa fa-ellipsis-v' : 'fa fa-navicon'
              "
            ></i>
          </button>
        </div>
        <div class="navbar-brand col-auto ps-0">
          <div id="navbar-breadcrumb"></div>
        </div>
      </div>
      <button
        type="button"
        class="navbar-toggler navbar-toggler-right"
        :class="{ toggled: $sidebar.showSidebar }"
        aria-expanded="false"
        @click="toggleSidebar"
      >
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="btn-group dropstart align-items-center me-lg-2">
        <el-select
          v-if="isAgrupacion"
          v-model="franquiciaSelected"
          @change="franquiciaChange"
          placeholder="Franquicia"
          size="small"
          filterable
          class="portal-header-franquicia ms-1"
        >
          <i
            slot="prefix"
            class="fa fa-home el-input__icon"
            aria-hidden="true"
          ></i>
          <el-option
            v-for="item in franquicias"
            :key="item._id"
            :label="`${item.codigo} ${item.nombre}`"
            :value="item._id"
          >
          </el-option>
        </el-select>
        <NotificationsMenu class="ms-2" />
        <span class="portal-header-separator mx-3" aria-hidden="true"></span>
        <button
          type="button"
          class="avatar-usuario portal-header-action"
          data-bs-toggle="dropdown"
          data-bs-display="static"
          aria-expanded="false"
          aria-label="Mi cuenta"
        >
          {{ iniciales }}
        </button>
        <ul class="dropdown-menu menu-usuario portal-header-popover">
          <li class="menu-usuario__cabecera">
            <span class="avatar-usuario avatar-usuario--grande portal-header-action">
              {{ iniciales }}
            </span>
            <div class="menu-usuario__identidad">
              <h6 class="menu-usuario__titulo">Mi cuenta</h6>
              <span v-if="usuario" class="menu-usuario__nombre">
                {{ usuario.user }}
              </span>
            </div>
          </li>
          <li class="px-2">
            <a class="dropdown-item hand" @click="cambiarPassword">
              <i class="fa fa-key"></i>
              Cambiar contraseña
            </a>
          </li>
          <li class="px-2 pb-2">
            <a class="dropdown-item hand" @click="cerrarSesion">
              <i class="fa fa-sign-out"></i>
              Cerrar sesión
            </a>
          </li>
        </ul>
      </div>
      <changePassword
        v-if="showChangePassword"
        @hide="showChangePassword = !showChangePassword"
        @guardado="cambiarPassword"
      />
    </div>
  </nav>
</template>
<script>
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import changePassword from "src/pages/Views/Franquicia/CambiarContraseña.vue";
import { entorno } from "@/globalVars";
import NotificationsMenu from "./Extra/NotificationsMenu.vue";
export default {
  components: {
    [CollapseTransition.name]: CollapseTransition,
    changePassword,
    NotificationsMenu,
  },
  computed: {
    nombreEntorno() {
      const nombres = {
        DEV: "Desarrollo",
        TEST: "Test",
        STAGING: "Staging",
        LOCAL: "Local",
      };
      return nombres[this.entorno] || this.entorno;
    },
    iniciales() {
      if (!this.usuario || !this.usuario.user) return "";
      const partes = this.usuario.user.split("@")[0].split(/[._\-\s]+/);
      return partes
        .filter((p) => p)
        .slice(0, 2)
        .map((p) => p[0].toUpperCase())
        .join("");
    },
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      entorno,
      usuario: null,
      isClosed: true,
      showChangePassword: false,
      franquicias: [],
      isAgrupacion: false,
      franquiciaSelected: "",
    };
  },
  mounted() {
    this.minimizeSidebar();
    this.usuario = JSON.parse(localStorage.getItem("user"));
    if (this.usuario.agrupacion) this.loadSelectFranquicias();
  },
  methods: {
    toggleMenu() {
      this.isClosed = !this.isClosed;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    abrirSideBar() {
      this.$sidebar.toggleMinimize();
    },
    minimizeSidebar() {
      this.$sidebar.ocultarSideBar();
    },
    cerrarSesion() {
      this.$store.dispatch("user/clearSession");
      this.$router.push({ name: "Login" });
    },
    showHideModalChangePassword() {
      this.showChangePassword = !this.showChangePassword;
    },
    cambiarPassword() {
      this.showHideModalChangePassword();
    },
    loadSelectFranquicias() {
      this.isAgrupacion = true;
      this.franquicias = this.usuario.agrupacion;
      this.franquiciaSelected = this.usuario.extraData.franquiciaId;
    },
    franquiciaChange(val) {
      this.$store.dispatch("user/updateSessionContext", {
        franquiciaId: val,
        franquicia: JSON.stringify({ _id: val }),
      });
      window.location.reload();
    },
  },
};
</script>
<style>
/* Alto fijo: coincide con la cabecera del menú lateral (SideBar.vue) */
.navbar.portal-navbar {
  position: relative;
  height: 61px;
  min-height: 61px;
}

/* Etiqueta del entorno (Desarrollo, Test…), solo fuera de producción:
   centrada en la cabecera y sin ocupar sitio en la fila */
.entorno-badge {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 4px 14px;
  border-radius: 4px;
  border: 1px solid #f4b13e;
  background-color: #f4b13e;
  color: #303133;
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
  pointer-events: none;
}

.style-button-icon {
  margin-right: 22px;
  margin-left: 9px;
}

.dropstart .menu-usuario[data-bs-popper] {
  top: calc(100% + 12px);
  right: 0;
  margin: 0;
}

.avatar-usuario {
  background-color: var(--portal-header-primary);
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.avatar-usuario:hover {
  background-color: var(--portal-header-primary-hover);
}

.avatar-usuario--grande {
  flex-shrink: 0;
  margin-left: 0;
}

.menu-usuario {
  min-width: 260px;
  font-size: 14px;
}

.menu-usuario__cabecera {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 20px 14px;
}

.menu-usuario__identidad {
  min-width: 0;
}

.menu-usuario__titulo {
  margin: 0;
  color: #303133;
  font-size: 16px;
  text-transform: none;
}

.menu-usuario__nombre {
  display: block;
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  overflow-wrap: anywhere;
}

.menu-usuario .dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 12px;
  color: #606266;
  font-size: 14px;
  white-space: normal;
}

.menu-usuario .dropdown-item:hover,
.menu-usuario .dropdown-item:focus {
  background-color: #f7f9fc;
  color: #303133;
}

.menu-usuario .dropdown-item i {
  width: 18px;
  flex-shrink: 0;
  color: #909399;
  font-size: 16px;
}

.divider-style {
  margin-bottom: 8px !important;
}
</style>
